import { toast } from "react-toastify";
import WebService from "./WebService";
import { DocumentDetailsInterface } from "../assets/interface/primeSharkWebsite_interface";
import moment from "moment";
import {
  profileJourneyInfo,
  removeFCMToken,
  storeRegisteredToken,
} from "../config/action";
import { Dispatch } from "redux";
import parsePhoneNumberFromString from "libphonenumber-js";

export default function dropdownApiCall(login_type: string, type: string) {
  return WebService.getAPI({
    action: `master-dropdown/${login_type}?type=${type}`,
    body: null,
    isShowError: false,
  })
    .then((res: any) => {
      if (res?.status) {
        const info = res?.list ?? [];
        return info;
      } else {
        toast.error(res.message);
      }
    })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}
export function dropdownApiNewcall(login_type: string, type1: string[]) {
  return WebService.postAPI({
    action: `master-values/${login_type}`,
    body: { type: type1 },
    isShowError: false,
  })
    .then((res: any) => {
      if (res?.status) {
        const info = res?.list ?? [];
        return info;
      } else {
        toast.error(res.message);
      }
    })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}

export async function registerDevice(FCMToken: string, dispatch: Dispatch) {
  return await WebService.postAPI({
    action: `register-device`,
    body: {
      token: FCMToken,
      push_type: "FCM",
    },
    isShowError: false,
  })
    .then((res: any) => { })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}
export async function unregisterDevice(FCMToken: string, dispatch: Dispatch) {
  return await WebService.postAPI({
    action: `unregister-device`,
    body: {
      token: FCMToken,
      push_type: "WEB_PUSH",
    },
    isShowError: false,
  })
    .then((res: any) => {
      console.log("Unregister success");

      dispatch({ type: "DELETE_IDS" });
      dispatch(removeFCMToken({}));

      console.log("Calling logout");

      WebService.logout();
    })
    .catch((error: any) => {
      console.error("Unregister failed", error);

      toast.error(error?.response?.data?.message);

      return error;
    })
    .finally(() => { });
}

// Mentor variants — hit the mentor-guarded routes so the FCM token is stored
// against the MentorUser model (deviceable_type = MentorUser), letting
// MentorChatMessageNotification + future mentor pushes find it.
export async function registerMentorDevice(FCMToken: string) {
  return await WebService.postAPI({
    action: `mentor/register-device`,
    body: {
      token: FCMToken,
      push_type: "FCM",
    },
    isShowError: false,
  }).catch((error: any) => {
    toast.error(error?.response?.data?.message);
    return error;
  });
}
export async function unregisterMentorDevice(
  FCMToken: string,
  dispatch: Dispatch,
) {
  return await WebService.postAPI({
    action: `mentor/unregister-device`,
    body: {
      token: FCMToken,
      // Match the customer flow's choice — actual push_type isn't used by the
      // server for unregister beyond validation.
      push_type: "WEB_PUSH",
    },
    isShowError: false,
  })
    .then(() => {
      dispatch({ type: "DELETE_IDS" });
      dispatch(removeFCMToken({}));
      WebService.logout();
    })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}
export function getCountryListAPiCall(keyword: string) {
  return WebService.getAPI({
    action: `countries?keyword=${keyword}`,
    body: null,
    isShowError: false,
  })
    .then((res: any) => {
      if (res?.status) {
        const info = res?.list ?? [];
        return info;
      } else {
        toast.error(res.message);
      }
    })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}
export function getDocumentIfAvailable(
  type: string,
  documentList: DocumentDetailsInterface[],
) {
  if (!documentList || documentList.length === 0) return null;

  const foundDocument = documentList.find((item) => item.type === type);

  return foundDocument
    ? {
      type: foundDocument.type,
      file_name: foundDocument.file_name,
      title: foundDocument.title,
      file_title: foundDocument?.file_title,
      id: foundDocument?.id,
    }
    : null;
}
export function formatAmount(amount1: string): string {
  if (!amount1) {
    return "";
  }

  let amount = parseFloat(amount1);
  if (amount >= 10000000) {
    return `$ ${(amount / 10000000).toFixed(2)} Cr`;
  } else if (amount >= 100000) {
    return `$ ${(amount / 100000).toFixed(2)} Lac`;
  } else if (amount >= 1000) {
    return `$ ${(amount / 1000).toFixed(2)} K`;
  } else {
    return `$ ${amount.toFixed(2)}`;
  }
}
export function formatCurrency(
  value: number | string,
  currencyCode: string = "INR",
  abbreviate: boolean = true
) {
  if (!value && value !== 0) return "-";

  const num = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(num)) return "-";

  const safeCurrencyCode = currencyCode || "USD";
  const currencyUpper = safeCurrencyCode.toUpperCase();

  // Currency symbols mapping
  const currencySymbols: { [key: string]: string } = {
    // Major currencies
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    INR: "₹",
    RUB: "₽",
    KRW: "₩",
    TRY: "₺",
    BRL: "R$",

    // Americas
    CAD: "C$",
    MXN: "MX$",
    ARS: "AR$",
    CLP: "CL$",
    COP: "CO$",
    PEN: "S/",
    UYU: "$U",
    VES: "Bs.",
    BOB: "Bs",

    // Europe
    CHF: "CHF",
    SEK: "kr",
    NOK: "kr",
    DKK: "kr",
    PLN: "zł",
    CZK: "Kč",
    HUF: "Ft",
    RON: "lei",
    BGN: "лв",
    HRK: "kn",
    ISK: "kr",
    UAH: "₴",

    // Asia-Pacific
    AUD: "A$",
    NZD: "NZ$",
    SGD: "S$",
    HKD: "HK$",
    TWD: "NT$",
    THB: "฿",
    MYR: "RM",
    IDR: "Rp",
    PHP: "₱",
    VND: "₫",
    PKR: "₨",
    BDT: "৳",
    LKR: "Rs",
    NPR: "Rs",
    MMK: "K",
    KHR: "៛",
    LAK: "₭",
    MNT: "₮",
    KZT: "₸",
    UZS: "soʻm",

    // Middle East & Africa
    AED: "AED ",
    SAR: "﷼",
    QAR: "ر.ق",
    KWD: "د.ك",
    OMR: "ر.ع",
    BHD: "د.ب",
    JOD: "د.ا",
    ILS: "₪",
    EGP: "E£",
    MAD: "د.م.",
    ZAR: "R",
    NGN: "₦",
    KES: "KSh",
    GHS: "₵",
    TZS: "TSh",
    UGX: "USh",
    ETB: "Br",
    DZD: "د.ج",

    // Others
    IQD: "ع.د",
    IRR: "﷼",
    AFN: "؋",
    AMD: "֏",
    GEL: "₾",
    AZN: "₼",
    BYN: "Br",
    MDL: "L",
  };

  const symbol = currencySymbols[currencyUpper] || currencyUpper + " ";

  const lakhCroreCountries = ["INR", "PKR", "BDT", "LKR", "NPR"];

  if (!abbreviate) {
    const locale = lakhCroreCountries.includes(currencyUpper) ? "en-IN" : "en-US";
    return symbol + Math.round(num).toLocaleString(locale);
  }

  if (lakhCroreCountries.includes(currencyUpper)) {
    if (num >= 10000000) {
      // 1 Crore
      return symbol + (num / 10000000).toFixed(2).replace(/\.00$/, "") + " Cr";
    } else if (num >= 100000) {
      // 1 Lakh
      return symbol + (num / 100000).toFixed(2).replace(/\.00$/, "") + " L";
    } else if (num >= 1000) {
      return symbol + (num / 1000).toFixed(2).replace(/\.00$/, "") + " K";
    }
    return symbol + Math.round(num).toLocaleString(currencyUpper === "INR" ? "en-IN" : "en-US");
  }

  // Japanese Yen and Korean Won - typically don't use decimals
  if (["JPY", "KRW", "VND", "IDR"].includes(currencyUpper)) {
    if (num >= 100000000) {
      // 100 Million (億 in Japanese)
      return symbol + (num / 100000000).toFixed(1).replace(/\.0$/, "") + " 億";
    } else if (num >= 10000) {
      // 10 Thousand (万 in Japanese/Korean)
      return symbol + (num / 10000).toFixed(1).replace(/\.0$/, "") + " 万";
    }
    return symbol + Math.round(num).toLocaleString();
  }

  // Chinese Yuan - uses 万 (10K) and 亿 (100M)
  if (currencyUpper === "CNY") {
    if (num >= 100000000) {
      return symbol + (num / 100000000).toFixed(2).replace(/\.00$/, "") + " 亿";
    } else if (num >= 10000) {
      return symbol + (num / 10000).toFixed(2).replace(/\.00$/, "") + " 万";
    } else if (num >= 1000) {
      return symbol + (num / 1000).toFixed(2).replace(/\.00$/, "") + " K";
    }
    return symbol + Math.round(num).toLocaleString();
  }

  // Standard Million-Billion format for most Western currencies
  if (num >= 1000000000) {
    // Billion
    return symbol + (num / 1000000000).toFixed(2).replace(/\.00$/, "") + " B";
  } else if (num >= 1000000) {
    // Million
    return symbol + (num / 1000000).toFixed(2).replace(/\.00$/, "") + " M";
  } else if (num >= 1000) {
    // Thousand
    return symbol + (num / 1000).toFixed(2).replace(/\.00$/, "") + " K";
  }

  return symbol + Math.round(num).toLocaleString();
}
export function formatAmountIntl(amount1: string): string {
  if (!amount1) return "";

  const amount = parseFloat(amount1);
  if (isNaN(amount)) return "";

  const format = (value: number) =>
    Number.isInteger(value) ? value.toString() : value.toFixed(2);

  if (amount >= 1_000_000_000_000) {
    return `${format(amount / 1_000_000_000_000)} T`;
  } else if (amount >= 1_000_000_000) {
    return `${format(amount / 1_000_000_000)} B`;
  } else if (amount >= 1_000_000) {
    return `${format(amount / 1_000_000)} M`;
  } else if (amount >= 1_000) {
    return `${format(amount / 1_000)} K`;
  } else {
    return format(amount);
  }
}

export function formatAmountWithCommas(amount1: string): string {
  if (!amount1) return "";

  const amount = parseFloat(amount1);
  if (isNaN(amount)) return "";

  return amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatAmountWithShortcutAndCommas(
  value: number | string | undefined | null,
  currencyCode?: string
): string {
  if (value === undefined || value === null || value === "" || value === "-") {
    return "-";
  }

  const cleanStr = String(value).replace(/[^0-9.-]/g, "");
  const num = parseFloat(cleanStr);

  if (isNaN(num)) {
    return String(value);
  }

  const safeCurrencyCode = (currencyCode || "USD").toUpperCase();

  const currencySymbols: { [key: string]: string } = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    INR: "₹",
    CAD: "C$",
    AUD: "A$",
    AED: "AED",
    SAR: "SAR",
    SGD: "S$",
    CHF: "CHF",
    NZD: "NZ$",
    QAR: "QAR",
    KWD: "KD",
    BHD: "BD",
    OMR: "OMR",
  };

  const rawSymbol = currencySymbols[safeCurrencyCode] || safeCurrencyCode;
  const symbol = rawSymbol ? `${rawSymbol.trim()} ` : "";

  const isLakhCroreLocale = ["INR", "PKR", "BDT", "LKR", "NPR"].includes(safeCurrencyCode);
  const locale = isLakhCroreLocale ? "en-IN" : "en-US";

  const hasDecimals = num % 1 !== 0;
  const commaFormatted = num.toLocaleString(locale, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  });

  let shortcut = "";
  if (num >= 10000000) {
    const cr = (num / 10000000).toFixed(2).replace(/\.00$/, "").replace(/(\.[0-9])0$/, "$1");
    shortcut = `${cr} Cr`;
  } else if (num >= 100000) {
    const lac = (num / 100000).toFixed(2).replace(/\.00$/, "").replace(/(\.[0-9])0$/, "$1");
    shortcut = `${lac} Lac`;
  } else if (num >= 1000) {
    const k = (num / 1000).toFixed(2).replace(/\.00$/, "").replace(/(\.[0-9])0$/, "$1");
    shortcut = `${k} K`;
  }

  if (shortcut) {
    return `${symbol}${commaFormatted} (${shortcut})`;
  }

  return `${symbol}${commaFormatted}`;
}

export function getFormatedDateChatTime(dt: any, format?: any) {
  if (!dt) return "";

  const localTime = moment.utc(dt).local();
  const currentTime = moment();

  if (format) {
    return localTime.format(format);
  }

  const diffInMinutes = currentTime.diff(localTime, "minutes");

  if (diffInMinutes < 1) {
    return "Just Now";
  }

  if (localTime.isSame(currentTime, "day")) {
    return localTime.format("hh:mm A") + ", Today";
  } else if (localTime.isSame(currentTime.clone().subtract(1, "day"), "day")) {
    return localTime.format("hh:mm A") + ", Yesterday";
  } else {
    return localTime.format("hh:mm A, DD-MM-YYYY");
  }
}
export function displayMobile(phoneNumber: string, dial_code: string) {
  if (!phoneNumber) return "";
  if (phoneNumber.startsWith("+")) {
    return phoneNumber;
  }
  let dialCode = dial_code?.includes("+") ? dial_code : `+${dial_code}`;
  return `${dialCode}-${phoneNumber}`;
}

export function isMobileNumberValid(phoneNumber: string, dialCode: string) {
  try {
    const fullNumber = phoneNumber.startsWith("+")
      ? phoneNumber
      : `+${dialCode}${phoneNumber}`;
    const parsedNumber = parsePhoneNumberFromString(fullNumber);
    return parsedNumber ? parsedNumber.isValid() : true;
  } catch (error) {
    return false;
  }
}

export function getCurrencyList() {
  return WebService.getAPI({
    action: `currencies`,
    body: null,
    isShowError: false,
  })
    .then((res: any) => {
      if (res?.status) {
        const info = res?.list ?? [];
        return info;
      } else {
        toast.error(res.message);
      }
    })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}

export const hasAllMandatoryDocs = (
  documentList: DocumentDetailsInterface[],
  MandatoryDoc: string[],
): boolean => {
  if (!documentList || documentList.length === 0) return false;
  const uploadedTypes = documentList.map((doc) => doc.type);
  return MandatoryDoc.every((requiredType) =>
    uploadedTypes.includes(requiredType),
  );
};

export const getCurrencySymbol = (currencyCode: string, locale = "en-US") => {
  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 0, // Set to 0 to avoid displaying decimal places for symbol extraction
      maximumFractionDigits: 0,
    });
    // Format a dummy number (e.g., 1) to get the formatted string parts
    const parts = formatter.formatToParts(1);
    // Find the part with type 'currency' and return its value
    const currencyPart = parts.find((part) => part.type === "currency");
    return currencyPart ? currencyPart.value : undefined;
  } catch (error) {
    return undefined;
  }
};

export const formatCurrency1 = (
  amount: number,
  currencyCode: string,
  locale = "en-US",
) => {
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    // Fallback in case of an invalid currencyCode or locale
    return `${currencyCode} ${amount.toFixed(2)}`;
  }
};

export const validatePassword = (value: string) => {
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return regex.test(value);
};

export const parseFundingRange = (range: string) => {
  if (!range || typeof range !== "string") {
    return {
      min: 0,
      max: 0,
    };
  }

  const cleanValue = (value: string): number => {
    if (!value) return 0;

    value = value.replace(/\$/g, "").trim().toUpperCase();

    if (value.includes("K")) {
      return parseFloat(value.replace("K", "").trim()) * 1000;
    }

    if (value.includes("M")) {
      return parseFloat(value.replace("M", "").trim()) * 1000000;
    }

    return Number(value.replace(/,/g, ""));
  };

  range = range.replace(/[–—]/g, "-");

  if (range.includes("Upto")) {
    return {
      min: 0,
      max: cleanValue(range.replace("Upto", "").trim()),
    };
  }

  if (range.includes("Above")) {
    return {
      min: cleanValue(range.replace("Above", "").trim()),
      max: Infinity,
    };
  }

  const [minStr, maxStr] = range.split("-");

  return {
    min: cleanValue(minStr),
    max: cleanValue(maxStr),
  };
};
export const validateAmount = (
  amount: number,
  selectedGoal: string,
  coversionRate: number | undefined,
) => {
  if (!selectedGoal) return false;

  const { min, max } = parseFundingRange(selectedGoal);

  let rate = coversionRate || 1;
  let minAmount = Math.round(min / rate);
  let maxAmount = Math.round(max / rate);

  console.log(
    amount,
    min + " >> " + minAmount,
    max + " >> " + maxAmount,
    selectedGoal,
  );
  return (
    Number(amount) >= Number(minAmount) && Number(amount) <= Number(maxAmount)
  );
};

export const getConvertedRangeLimits = (
  selectedGoal: string,
  coversionRate: number | undefined,
  currencyCode: string = "USD",
) => {
  if (!selectedGoal) return "";
  const { min, max } = parseFundingRange(selectedGoal);
  let rate = coversionRate || 1;
  // console.log("conversion rate : " + rate, selectedGoal);
  // console.log("min and max : " + min, max);

  let minAmount = Math.round(min * rate);
  let maxAmount = Math.round(max * rate);
  // console.log("minAmount : " + minAmount, maxAmount);

  const safeCurrencyCode = currencyCode || "USD";
  const minStr = formatCurrency(minAmount, safeCurrencyCode);
  const maxStr = max === Infinity ? "Infinity" : formatCurrency(maxAmount, safeCurrencyCode);

  return `${minStr} to ${maxStr}`;
};

export function getProfileJourneyInfo(
  type: string,
  business_uuid: string,
  dispatch: Dispatch,
) {
  return WebService.getAPI({
    action: `profile-journey/${type}/${business_uuid}`,
    body: null,
    isShowError: false,
  })
    .then((res: any) => {
      if (res?.status) {
        dispatch(profileJourneyInfo(res));
      } else {
      }
    })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}

export function updateProfileJourney(type: string, uuid: string, payload: any) {
  return WebService.postAPI({
    action: `profile-journey/update/${type}/${uuid}`,
    body: payload,
    isShowError: false,
  })
    .then((res: any) => {
      if (res?.status) {
        return res;
      } else {
        toast.error(res.message);
      }
    })
    .catch((error: any) => {
      toast.error(error?.response?.data?.message);
      return error;
    });
}

/**
 * Postal / ZIP code validation. Optional field — an empty value passes.
 * Permissive & international: letters, digits, spaces and hyphens (2–10 chars),
 * so alphanumeric codes like "SW1A 1AA" (UK), "M5V 3L9" (CA), "1234 AB" (NL)
 * and "411045" (IN) all pass, while emojis / special chars are rejected.
 */
export const PINCODE_REGEX = /^[A-Za-z0-9][A-Za-z0-9 -]{1,9}$/;
export const PINCODE_ERROR =
  "Please enter a valid postal / ZIP code (letters and numbers only).";
export const isValidPincode = (v?: string | null): boolean => {
  const s = (v || "").trim();
  return s === "" || PINCODE_REGEX.test(s);
};

/**
 * True when a multi-select option is the free-text "Other" bucket. Master data
 * marks it with `is_other === 1`; the label may read "Miscellaneous / Other"
 * (not literally "Other"), so we match on the flag first and keep the literal
 * label as a fallback for older payloads.
 */
export const isOtherOption = (item: any): boolean =>
  !!item &&
  (item.is_other === 1 ||
    item.is_other === "1" ||
    item.is_other === true ||
    item.label === "Other");

/**
 * Display label for an industry / market-focus chip. For the free-text "Other"
 * bucket we show ONLY the entered value (e.g. "Technology Mentor") instead of
 * "Miscellaneous / Other (Technology Mentor)". Backend chips arrive as
 * { title, other } (no is_other flag), and only the "Other" bucket ever carries
 * a non-empty `other`, so keying on that value alone is safe.
 */
export const chipDisplayLabel = (item: any): string => {
  const base = item?.title || item?.label || item?.value || "";
  const other = (item?.other || "").trim();
  return other ? other : base;
};
